import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@sunbit-dev/translations';
import * as styles from './styles';
import { CustomerSendVerificationPopupProps } from './models';
import { newPopup as Popup, SubtitleV2 as Subtitle } from '@sunbit-dev/web-ui-lib';
import useTimer from '../../hooks/useTimer';
import classNames from 'classnames';
import { getTime } from '../../utilities/time';
import { PopupWrapper } from '../popup/Popup';

const baseDuration = 60;

export const CustomerSendVerificationPopup = styled(
  ({ className, onClose, noLightBox, resendCallback, phoneNumber }: CustomerSendVerificationPopupProps) => {
    const { t } = useTranslation('components', { keyPrefix: 'customer_verification_popup' });

    const { countDown, startCountDown, increaseTimer } = useTimer(baseDuration);

    const lastDigits = useMemo(() => phoneNumber.slice(phoneNumber.length - 4, phoneNumber.length), [phoneNumber]);

    const onLaunchClick = useCallback(() => {
      increaseTimer();
      startCountDown();
      resendCallback();
    }, []);

    const onSendAgain = useCallback(() => onLaunchClick(), []);

    const footer = (
      <div className="footer">
        <Subtitle className="send-again-title" alignLeft={false}>
          {t('resend_title')}
        </Subtitle>
        <div className={classNames('send-again', { disabled: countDown })}>
          <span className="send-again-text" {...{ tabIndex: 0, onClick: onSendAgain }}>
            {t('resend_link')}
          </span>
          <span className="time-count">{` (${getTime(countDown)})`}</span>
        </div>
      </div>
    );

    return (
      <PopupWrapper {...{ className }}>
        <Popup
          {...{
            className: 'popup',
            boldText: t('title', { lastDigits }),
            dataTestId: 'customer-verification-popup',
            noLightBox,
            noFooterButtons: true,
            onClose,
          }}
        >
          <p>{t('subtitle')}</p>
          {footer}
        </Popup>
      </PopupWrapper>
    );
  }
)`
  ${styles.CustomerSendVerificationPopup}
`;
